@if (initialized) {
<div class="mx-auto p-2" style="max-width: 45rem;">
<div class="text-center mb-6">
  <div class="text-color text-3xl font-semibold mb-2">Benachrichtigungen</div>
  <span class="text-color-secondary text-sm">Wir wollen, dass du immer auf dem aktuellen Stand bist. Wähle bitte aus, wie wir dich kontaktieren dürfen.</span>
</div>

  <div [formGroup]="formGroup">

    <div class="contact-preference" *ngFor="let field of notificationFields">
      <div class="flex justify-content-between">
        <div class="">
          <label class="font-medium" [for]="field.id"> {{field.uiLabel}}
            <span *ngIf="field.uiMandatory" class="text-red-400 font-normal">(Erforderlich)</span>
              <i [pTooltip]="field.uiLongDescription" class="pi pi-info-circle text-color-secondary mx-2 cursor-pointer"></i>
          </label>
          <p class="pt-2">{{field.uiDescription}}</p>
        </div>
        <div class="">
          <p-inputSwitch [id]="field.id" [formControlName]="field.id"></p-inputSwitch>
        </div>
      </div>
    </div>

  </div>

  <div class="flex justify-content-between col-12 py-4">
    <div>
      <p-button [disabled]="busy" (click)="navigatePreviousStep(3)"  label="Zurück" severity="secondary" [text]="true" iconPos="left" icon="pi pi-arrow-left"></p-button>
    </div>

    <div>
<!--      <p-button [disabled]="!isFormValid()" (click)="updateRegistration()" label="weiter" icon="pi pi-arrow-right" iconPos="right"></p-button>-->
      <app-button [disabled]="!isFormValid()"
                  [busy]="busy"
                  (onClick)="updateRegistration()">
      </app-button>
    </div>
  </div>

</div>

}
